export default "/arrow.182bbe10-5032ee.svg?url";